import React from 'react';
import IndividualCharacteristics from "./charLayout_individual";

export const renderer = (tBallot, allPoints, ballot, locked, content, promptStatuss, rEvent) => {
    const {competitorId} = tBallot.state; 
    return (<>
        <div className="row">
            <div className="col-12">
                {ballot && ballot.competitors.filter(x => {
                            var doesMatch = true;
                            if (competitorId) doesMatch = x.userId === competitorId;
                            return (doesMatch && x.role === tBallot.bConfig.roles[0][1])
                        }).map((competitor, index) => {
                    return (
                        <IndividualCharacteristics key={index} tBallot={tBallot} updateContents={tBallot.onUpdateContents}
                            competitor={competitor}
                            content={competitor.content}
                            rankCount={ballot.competitors.length}
                            allPoints={allPoints}
                            readOnly={locked}
                            options={tBallot.bConfig.characteristics}
                            promptStatus={promptStatuss ? promptStatuss.find(x=>x.userId === competitor.userId): null}
                            rEvent={rEvent}
                            isSubmitted={ballot.isSubmitted}
                        />
                    )
                })
                }
            </div>
        </div>

    </>)
}
